import React, { memo } from 'react';
import { BookOpen, Shield, Eye, FileSearch, Globe, Lock, CheckCircle2 } from 'lucide-react';
import { Button, Section } from './Shared';
import { trackFb } from '../lib/fbpixel';
const volumes = [{
  num: 1,
  title: 'El cielo no estaba vacío',
  desc: 'Una mirada a los antecedentes del fenómeno antes de que tuviera nombre institucional.',
  points: ['Registros antiguos y casos tempranos', 'Roswell y sus fuentes públicas', 'Prensa, archivos y contexto histórico', 'El inicio del debate moderno']
}, {
  num: 2,
  title: 'El nacimiento del fenómeno moderno',
  desc: 'Los casos que ayudaron a instalar el fenómeno en la conversación del siglo XX.',
  points: ['Avistamientos fundacionales', 'Informes y primeras investigaciones', 'Incidentes que marcaron época', 'Cómo se construyó el relato público']
}, {
  num: 3,
  title: 'Casos militares y pilotos',
  desc: 'Encuentros documentados donde intervienen personal entrenado, radares y aeronaves.',
  points: ['Reportes de pilotos', 'Registros de radar y persecuciones', 'Casos aéreos relevantes', 'Testimonios de personal militar']
}, {
  num: 4,
  title: 'Los contactados',
  desc: 'Relatos de encuentros cercanos analizados desde su contexto histórico y cultural.',
  points: ['Casos de contacto célebres', 'Figuras y testimonios recurrentes', 'Relatos de humanoides', 'Lecturas e hipótesis del fenómeno']
}, {
  num: 5,
  title: 'UAP y revelaciones recientes',
  desc: 'El nuevo lenguaje institucional y los casos que reabrieron la discusión pública.',
  points: ['Videos oficiales y UAP', 'Informes del Pentágono', 'Audiencias y declaraciones públicas', 'Qué se sabe y qué sigue abierto']
}, {
  num: 6,
  title: 'Hipótesis y futuro',
  desc: 'Un mapa de explicaciones posibles para pensar el fenómeno con mejor criterio.',
  points: ['Modelos explicativos principales', 'Evidencia, límites y preguntas', 'Debates actuales', 'Escenarios para futuras investigaciones']
}];
export function Volumes() {
  return <Section data-id="element-4">
      <div className="text-center max-w-2xl mx-auto mb-8" data-id="element-5">
        <p className="text-xs font-bold tracking-[0.18em] text-brand-gold uppercase mb-3" data-id="element-6">
          La colección central
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-7">
          Seis tomos para recorrer el Archivo con contexto
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-8">
        {volumes.map(vol => <div key={vol.num} className="bg-brand-dark border border-brand-card rounded-xl p-6 hover:border-brand-gold/30 transition-colors group" data-id="element-9">
            <div className="text-brand-gold/50 font-serif text-4xl font-bold mb-4 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-10">
              0{vol.num}
            </div>
            <h4 className="text-lg font-bold text-white mb-2" data-id="element-11">
              Volumen {vol.num} — {vol.title}
            </h4>
            <p className="text-sm text-brand-muted mb-4 leading-relaxed" data-id="element-12">
              {vol.desc}
            </p>
            <ul className="space-y-2 border-t border-brand-card pt-4" data-id="element-13">
              {vol.points.map(point => <li key={point} className="flex items-start gap-2 text-xs text-brand-offWhite" data-id="element-14">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-gold shrink-0 mt-0.5" data-id="element-15" />
                  <span data-id="element-16">{point}</span>
                </li>)}
            </ul>
          </div>)}
      </div>
      <div className="mt-12 text-center" data-id="element-17">
        <Button onClick={() => {
        trackFb('AddToCart', {
          content_name: 'Colección NOS MIENTEN',
          currency: 'ARS',
          value: 27990
        });
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-18">
          QUIERO ACCEDER A LA COLECCIÓN
        </Button>
      </div>
    </Section>;
}
const bonuses = [{
  title: 'El Libro Negro de los Misterios Modernos',
  desc: 'Una investigación especial sobre Dyatlov, Bermudas, Rendlesham, Phoenix, Pascagoula y otros casos que siguen abriendo preguntas.',
  img: 'https://cdn.magicpatterns.com/uploads/muv5cDvaQo563DWbnPUxWq/ChatGPT_Image_26_jun_2026,_18_43_48.png'
}, {
  title: 'Los Archivos Desclasificados',
  desc: 'Una investigación especial para recorrer documentos, memorandos y expedientes con el contexto necesario para entender qué se publicó y qué permanece abierto.',
  img: 'https://cdn.magicpatterns.com/uploads/aPyt7oTA5hXLKB4qtibUJ2/ChatGPT_Image_26_jun_2026,_18_40_49.png'
}, {
  title: 'Las Grandes Civilizaciones Perdidas',
  desc: 'Una investigación especial sobre Atlántida, Göbekli Tepe, Puma Punku, Nan Madol, Yonaguni, Nazca y las preguntas que todavía despiertan.',
  img: 'https://cdn.magicpatterns.com/uploads/9mknbYHtgSMxsyghVyTgAh/ChatGPT_Image_26_jun_2026,_18_40_36.png'
}];
export function Bonuses() {
  return <Section darker data-id="element-19">
      <div className="text-center mb-12" data-id="element-20">
        <p className="text-xs font-bold tracking-[0.18em] text-brand-gold uppercase mb-3" data-id="element-21">
          Investigaciones exclusivas
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-22">
          Tres investigaciones especiales para{' '}
          <span className="text-brand-gold" data-id="element-23">expandir tu biblioteca</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-24">
        {bonuses.map((bonus, idx) => <div key={idx} className="bg-brand-anthracite border border-brand-card rounded-xl overflow-hidden group" data-id="element-25">
            <div className="relative overflow-hidden bg-brand-dark p-4" data-id="element-26">
              <img src={bonus.img} alt={bonus.title} className="w-full h-auto object-contain rounded shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-27" />
              <div className="absolute top-6 right-6 bg-brand-gold text-brand-dark text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-28">
                Investigación especial
              </div>
            </div>
            <div className="p-6" data-id="element-29">
              <h4 className="text-lg font-bold text-white mb-3" data-id="element-30">
                {bonus.title}
              </h4>
              <p className="text-sm text-brand-muted" data-id="element-31">{bonus.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}
const benefits = [{
  icon: FileSearch,
  title: 'Más orden',
  desc: 'Dejá de saltar entre fragmentos sueltos y empezá a ver el panorama completo.'
}, {
  icon: Globe,
  title: 'Más contexto',
  desc: 'Entendé cómo se conectan los casos y por qué algunos importan más que otros.'
}, {
  icon: Shield,
  title: 'Mejor criterio',
  desc: 'Aprendé a distinguir evidencia, hipótesis y puro humo.'
}, {
  icon: Eye,
  title: 'Experiencia premium',
  desc: 'No comprás solo información: entrás a una biblioteca documental visualmente poderosa.'
}, {
  icon: BookOpen,
  title: 'Material para releer',
  desc: 'Es una obra para consultar, subrayar y volver a explorar.'
}];
export function Benefits() {
  return <Section data-id="element-32">
      <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-33">
        <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-34">
          Lo que esta colección te da que un video suelto o un hilo de internet
          no puede darte
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-35">
        {benefits.map((item, idx) => <div key={idx} className="bg-brand-dark p-6 rounded-xl border border-brand-card flex flex-col items-center text-center" data-id="element-36">
            <div className="w-12 h-12 bg-brand-anthracite rounded-full flex items-center justify-center mb-4 border border-brand-card" data-id="element-37">
              <item.icon className="w-5 h-5 text-brand-gold" data-id="element-38" />
            </div>
            <h4 className="text-white font-bold mb-2" data-id="element-39">{item.title}</h4>
            <p className="text-sm text-brand-muted" data-id="element-40">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}
const lockedInvestigations = [{
  title: 'Antártida: El Continente Prohibido',
  desc: 'Expediciones, mapas imposibles, Highjump y los grandes interrogantes bajo el hielo.',
  img: 'https://cdn.magicpatterns.com/uploads/b2d3RxP8RvvtsMx9CN4qFa/ChatGPT_Image_26_jun_2026,_18_39_12.png'
}, {
  title: 'Los Evangelios Perdidos',
  desc: 'Textos excluidos, manuscritos antiguos, Nag Hammadi y preguntas que la historia religiosa nunca cerró del todo.',
  img: 'https://cdn.magicpatterns.com/uploads/vUFMGMqEmkprkCjAucEFf6/ChatGPT_Image_26_jun_2026,_18_39_30.png'
}];
export function PostPurchase() {
  return <Section darker className="border-t border-brand-card relative overflow-hidden" data-id="element-41">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-red/5 blur-[100px] rounded-full pointer-events-none" data-id="element-42" />
      <div className="text-center max-w-2xl mx-auto mb-10 relative z-10" data-id="element-43">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-brand-card bg-brand-dark text-brand-muted text-xs font-bold tracking-widest uppercase mb-4" data-id="element-44">
          <Lock className="w-3 h-3" data-id="element-45" />
          <span data-id="element-46">Contenido Bloqueado</span>
        </div>
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-47">
          Y esto no termina acá…
        </h2>
        <p className="text-brand-muted text-base" data-id="element-48">
          Después de acceder a la colección principal, vas a poder desbloquear
          investigaciones especiales con descuento exclusivo para compradores.
        </p>
        <p className="text-brand-gold text-sm mt-2 font-medium" data-id="element-49">
          Primero entrás al archivo central. Después, si querés, expandís tu
          biblioteca.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto relative z-10" data-id="element-50">
        {lockedInvestigations.map(item => <div key={item.title} className="group bg-brand-anthracite border border-brand-card border-dashed rounded-xl overflow-hidden relative" data-id="element-51">
            <div className="relative overflow-hidden bg-brand-dark p-4" data-id="element-52">
              <img src={item.img} alt={`Portada de ${item.title}`} className="w-full h-auto object-contain rounded shadow-2xl" data-id="element-53" />
              <div className="absolute top-6 right-6 inline-flex items-center gap-1.5 bg-brand-dark/80 backdrop-blur-sm px-2.5 py-1 rounded border border-brand-card text-[10px] font-bold text-brand-offWhite tracking-widest uppercase" data-id="element-54">
                <Lock className="w-3 h-3 text-brand-gold" data-id="element-55" />
                <span data-id="element-56">Bloqueado</span>
              </div>
            </div>
            <div className="p-6" data-id="element-57">
              <h4 className="text-lg font-bold text-white mb-2" data-id="element-58">
                {item.title}
              </h4>
              <p className="text-sm text-brand-muted mb-4" data-id="element-59">{item.desc}</p>
              <span className="inline-block text-[11px] font-bold text-brand-gold tracking-widest uppercase" data-id="element-60">
                Se desbloquea después de tu compra
              </span>
            </div>
          </div>)}
      </div>
      <p className="text-center text-xs text-brand-muted mt-8 max-w-xl mx-auto" data-id="element-61">
        Estas investigaciones especiales no forman parte de esta oferta
        principal. Se desbloquean después de tu compra.
      </p>
    </Section>;
}